import type { FilterFieldOption } from '~/components/ui';
import { SavedViewsFilterControls } from '~/components/ui/SavedViewsFilterControls';
import { activeRowCount } from '~/pages/order-builder/lib/comparisonFilters';
import type { ComparisonSavedViews } from '~/pages/order-builder/lib/useComparisonSavedViews';
import { ComparisonFilter } from '~/pages/order-builder/sections/ComparisonFilter';

type ComparisonToolbarProps = {
  readonly fieldOptions: FilterFieldOption[];
  readonly views: ComparisonSavedViews;
};

export function ComparisonToolbar({
  fieldOptions,
  views,
}: ComparisonToolbarProps) {
  return (
    <div className="flex-1 min-w-0 flex items-center gap-4">
      <SavedViewsFilterControls
        namespace="order-builder"
        keyPrefix="order_builder.filter"
        views={views}
        activeCount={activeRowCount(views.rows)}
        buttonTestId="comparison-filter-button"
        countTestId="comparison-filter-count"
        popoverAlign="start"
        popoverZIndex="100"
        renderPanel={({ maxHeight, bottomContent }) => (
          <ComparisonFilter
            maxHeight={maxHeight}
            bottomContent={bottomContent}
            rows={views.rows}
            fieldOptions={fieldOptions}
            onRowsChange={views.setRows}
          />
        )}
      />
    </div>
  );
}
